import { Outlet } from "react-router-dom";

const PickupsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PickupsPage;
